import { Box, Palette, useTheme } from '@mui/material';

export interface StatusIndicatorProps {
  variant: keyof Pick<
    Palette,
    | 'primary'
    | 'secondary'
    | 'info'
    | 'neutral'
    | 'warning'
    | 'error'
    | 'success'
  >;

  size?: 'small' | 'large';
}

export const StatusIndicator = ({
  variant,
  size = 'small',
}: StatusIndicatorProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: size === 'small' ? '6px' : '8px',
        height: size === 'small' ? '16px' : '24px',
        border: `1px solid ${theme.palette[variant].dark}`,
        borderRadius: '4px',
        backgroundColor: theme.palette[variant].main,
      }}
    />
  );
};
